import { createFileRoute, notFound } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { PageSeo } from './-components/page-seo';
import { audiencePageSlugs, parseAudience, parseTab } from './-components/contact/audiences';

/**
 * A tab of an audience page that has its own URL — today only the NGO panel's "I want to ask", which
 * is a form, so it has to be linkable and to survive a reload. The shell reads the same param to open
 * that tab, so landing here directly and clicking through to it produce the identical page.
 */
export const Route = createFileRoute('/new/contact/$audience/$tab')({
	// A tab that does not exist under this audience is a 404, not a silent fallback to the default: the
	// URL would otherwise claim a page we do not serve, which is the soft 404 `/new/$` exists to avoid.
	beforeLoad: ({ params }) => {
		if (!parseTab(parseAudience(params.audience), params.tab)) throw notFound();
	},
	component: Component,
});

function Component() {
	const { t } = useLingui();
	const { audience, tab } = Route.useParams();
	const parsedAudience = parseAudience(audience);
	const parsedTab = parseTab(parsedAudience, tab);
	if (!parsedAudience || !parsedTab) return null;

	return (
		<PageSeo
			slugs={audiencePageSlugs(parsedAudience, parsedTab)}
			title={t`Ask us a question - Worldcoo`}
			description={t`Are you already collaborating with Worldcoo, or do you have a question about how our fundraising channels work? Write to us and our team will reply.`}
		/>
	);
}
